import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';

const initialState = {
  totalPages: 0,
};
export const useDriversList = create(
  immer((set, get) => ({
    ...initialState,
    setTotalPages: (payload) =>
      set((state) => {
        state.totalPages = payload;
      }),
  }))
);
